import React from "react";
// nodejs library that concatenates classes
// reactstrap components
import {
    Button,
    Card,
    CardBody,
    Col,
    Container,
    FormGroup,
    Input,
    InputGroup,
    InputGroupAddon,
    InputGroupText,
    Row
} from "reactstrap";

// core components
import MainNavbar from "components/Navbars/MainNavbar.js";

// index page sections
import CardsFooter from "../components/Footers/CardsFooter";
import classnames from "classnames";

// Women at Imperial Week 2024
class WaIW extends React.Component {
    state = {};

    componentDidMount() {
        document.documentElement.scrollTop = 0;
        document.scrollingElement.scrollTop = 0;
        this.refs.main.scrollTop = 0;
    }

    chunkArrayInGroups(arr, size) {
        var myArray = [];
        for (var i = 0; i < arr.length; i += size) {
            myArray.push(arr.slice(i, i + size));
        }
        return myArray;
    }

    render() {
        return (
            <>
                <MainNavbar/>
                <main ref="main">
                    <div className="position-relative">
                        {/* shape Hero */}
                        <section className="section section-lg section-shaped pb-250">
                            <div className="shape shape-style-1 shape-default">
                            </div>
                            <Container className="py-lg-md d-flex">
                                <div className="col px-0">
                                    <Row>
                                        <Col lg="8">
                                            <h1 className="display-3 text-white">
                                                Women at Imperial Week
                                                <span>2024</span>
                                            </h1>
                                            <p className="lead text-white" style={{fontSize: "24px"}}>
                                                The week is an annual opportunity to shine a light both on the many achievements of women 
                                                working and studying at the College and on the remaining challenges in achieving gender equality. 
                                                <br></br><u><a href="https://www.imperial.ac.uk/equality/events/women-at-imperial/" style = {{color: "white"}}>More information on Imperial's website here!</a></u>
                                                {/* &nbsp; */}
                                                {/* <Button
                                                    block
                                                    className="btn-white"
                                                    color="default"
                                                    target={"_blank"}
                                                    href="https://www.imperial.ac.uk/equality/events/women-at-imperial/"
                                                    size="lg"
                                                >
                                                    Click here for more info!
                                                </Button> */}
                                                {/* <a href="https://www.imperial.ac.uk/equality/events/women-at-imperial/" target="_blank">Click here for more info!</a> */}
                                            </p>
                                        </Col>
                                        <Col lg={"4"}>
                                            {window.innerWidth > 560 && (
                                                <img
                                                style={{ width: "100%", marginTop: "30px" }}
                                                alt="..."
                                                src={require("assets/img/brand/wicLogo.png")}
                                                />
                                            )}
                                        </Col>
                                    </Row>
                                </div>
                            </Container>
                            {/* SVG separator */}
                            <div className="separator separator-bottom separator-skew">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    preserveAspectRatio="none"
                                    version="1.1"
                                    viewBox="0 0 2560 100"
                                    x="0"
                                    y="0"
                                >
                                    <polygon
                                        className="fill-white"
                                        points="2560 0 2560 100 0 100"
                                    />
                                </svg>
                            </div>
                        </section>
                        {/* 1st Hero Variation */
                        }
                    </div>

                    <section id="upcoming" className="section section-lg">
                        <Container>
                            <Row className="justify-content-center text-center">
                                <Col lg="8">
                                    <h2 className="display-3">Events Timeline</h2>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={"12"}>
                                    <p>
                                        <br></br>
                                        {/* Check back later for the timeline of events happening that week! */}
                                        <ul className="h5 text-center" style={{listStyleType: 'none'}}>
                                            <li style={{marginBottom: '20px'}}><b>Monday 4th March</b> 8:30 - 11:30, Huxley Foyer, <u><a href="https://www.eventbrite.co.uk/e/women-at-imperial-week-kick-off-breakfast-tickets-848185374287">Women at Imperial Week Breakfast</a></u></li>
                                            <li style={{marginBottom: '20px'}}><b>Wednesday 6th March</b> 12:00 - 14:00, Huxley 311, <u><a href="https://www.eventbrite.co.uk/e/wic-x-wset-x-wieee-women-in-tech-careers-panel-networking-tickets-828352473547">WiC X WSET X WiEEE Industry Panel</a></u></li>
                                            <li style={{marginBottom: '20px'}}><b>Thursday 7th March</b> 18:00 - 20:00, EENG 508, <u><a href="https://www.eventbrite.co.uk/e/jewellery-making-social-tickets-828337599057">Jewellery Making Social with My Trove Jewels</a></u> (Tickets required)</li>
                                            <li style={{marginBottom: '20px'}}><b>Friday 8th March</b> 12:00 - 14:00, <u><a href="https://www.eventbrite.co.uk/e/bloomberg-pizza-social-tickets-828345452547">International Women's Day (Pizza Fridays with Bloomberg)</a></u></li>
                                        </ul>
                                    </p>
                                </Col>
                            </Row>
                        </Container>
                    </section>
                    <section id="upcoming" className="section section-lg">
                        <Container>
                            <Row className="justify-content-center text-center">
                                <Col lg="8">
                                    <h2 className="display-3">Photo Gallery</h2>
                                </Col>
                            </Row>
                            <Row className="h5 text-center">
                                <br></br>
                                Check back here later for the
                                Image Gallery ;)
                            </Row>
                        </Container>
                    </section>
                    <section id="contact" className="bg-primary" style={{paddingBottom: "100px"}}>
                        <Container className="pt-lg">
                            <Row className="text-center justify-content-center">
                                <Col lg="10">
                                    <h2 className="display-3 text-white">Contact Us</h2>
                                    <p className="lead text-white">
                                        Use the contact form below to get in touch with us!
                                    </p>
                                </Col>
                            </Row>
                            <Row className="justify-content-center">
                                <Col lg="8">
                                    <Card className="bg-gradient-secondary shadow">
                                        <CardBody className="p-lg-5">
                                            <h4 className="mb-1">Just fill out the form below!</h4>
                                            <form id="contactform"
                                                  action="https://formsubmit.io/send/ff1fab0a-a2bd-419b-b8ac-489d4d39c468"
                                                  method="POST">
                                                <input name="_formsubmit_id" type="text" style={{display: "none"}}/>
                                                <input name="_redirect" type="hidden" id="name"
                                                       value="http://wic.doc.ic.ac.uk"/>
                                                <FormGroup
                                                    className={classnames("mt-5", {
                                                        focused: this.state.nameFocused
                                                    })}
                                                >
                                                    <InputGroup className="input-group-alternative">
                                                        <InputGroupAddon addonType="prepend">
                                                            <InputGroupText>
                                                                <i className="ni ni-circle-08"/>
                                                            </InputGroupText>
                                                        </InputGroupAddon>
                                                        <Input
                                                            placeholder="Your name"
                                                            type="text"
                                                            name="name"
                                                            onFocus={e => this.setState({nameFocused: true})}
                                                            onBlur={e => this.setState({nameFocused: false})}
                                                        />
                                                    </InputGroup>
                                                </FormGroup>
                                                <FormGroup
                                                    className={classnames({
                                                        focused: this.state.emailFocused
                                                    })}
                                                >
                                                    <InputGroup className="input-group-alternative">
                                                        <InputGroupAddon addonType="prepend">
                                                            <InputGroupText>
                                                                <i className="ni ni-email-83"/>
                                                            </InputGroupText>
                                                        </InputGroupAddon>
                                                        <Input
                                                            placeholder="Email address"
                                                            type="email"
                                                            name="email"
                                                            onFocus={e => this.setState({emailFocused: true})}
                                                            onBlur={e => this.setState({emailFocused: false})}
                                                        />
                                                    </InputGroup>
                                                </FormGroup>
                                                <FormGroup className="mb-4">
                                                    <Input
                                                        className="form-control-alternative"
                                                        cols="80"
                                                        name="message"
                                                        placeholder="Type a message..."
                                                        rows="4"
                                                        type="textarea"
                                                    />
                                                </FormGroup>
                                                <div>
                                                    <Button
                                                        block
                                                        className="btn-round"
                                                        color="primary"
                                                        size="lg"
                                                        type="submit"
                                                    >
                                                        Send Message
                                                    </Button>
                                                </div>
                                            </form>

                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                        </Container>

                    </section>
                </main>
                <CardsFooter/>
            </>
        )
            ;
    }
}

export default WaIW;
